import React from 'react'
import './VPSPage.scss'
import Helmet from 'reactor/components/Helmet'
import BreadcrumbWithImage from '../../../../components/BreadcrumbWithImage'
import Features from '../../../components/features/Features'
import { makeStyles } from '@material-ui/core/styles';
import SupportWeb from '../../support/Support'
import BreadcrumbImage from 'assets/images/vpsimg.png'
import Phone from 'assets/images/phone.png'
import Backup from 'assets/images/backup.png'
import SSL from 'assets/images/ssl.png'
import PHP from 'assets/images/php.png'
import KVM from 'assets/images/kvm.png'
import Warranty from 'assets/images/warranty.png'
import Window from 'assets/images/window.png'
import Wifi from 'assets/images/wifi.png'
import SupportImg from 'assets/images/vpssupport.png'
import VPSPackagesTable from '../../VPSPackagesTable'
import PageContent from '../../../../components/PageContent'
import Heading from '../../../../components/heading'

const features = [
    {
        title: "تقسيمه عبر KVM",
        content: "تقسيم من نوع kvm هو الأفضل.",
        img: KVM,
    },
    {
        title: "أفضل أداء وسرعة لموقعك",
        content: "أفضل استقرار و سرعة في أداء موقعك الإلكتروني.",
        img: PHP,
    },
    {
        title: "حماية ضد هجمات DDOS",
        content: "حماية من هجمات حجب الخدمة.",
        img: Warranty,
    },
    {
        title: " حسابات البريد الإلكتروني",
        content: "عدد غير محدود من حسابات البريد الإلكتروني.",
        img: Wifi,
    },
    {
        title: "نقل آمن لموقعك",
        content: "يتم النقل بشكل آمن و والتفعيل فى أسرع وقت.",
        img: Window,
    },
    {
        title: "تفعيل خاصية النسخ الاحتياطي ",
        content: " ليتم الرجوع اليها في حالة حدوث مشكلة.",
        img: Backup,
    },
    {
        title: "شهادة حماية SSL",
        content: "شهادة الاتصال الآمن توفر لك نقل البيانات بشكل مشفر.",
        img: SSL,
    },
    {
        title: "الدعم الفني",
        content: "لمساعدتك  عند حدوث المشاكل التقنية.",
        img: Phone,
    },

]

const options = [
    "السعر",
    "عدد المعالجات",
    "نوعية المعالج",
    "نظام التشغيل",
    "المساحه",
    "الترافك المفتوح",
    "مساحة الذاكرة",
    " الطلب",
]

const packages = [
    {
        packageTitle: "الباقة الثالثة",
        price: '399',
        options: {
            numOfProcessor: '8 معالج',
            processorType:  'Xeon E3 - 1240',
            os: "CentOS 5",
            space:'400 جيجا بايت',
            traffic: 'مفتوح - غير محدود',
            memory : '5120 MB ميجا بايت'
        },
        class: "package-3"
    },
    {
        packageTitle: "الباقة الثانية",
        price: '299',
        options: {
            numOfProcessor: '8 معالج',
            processorType:  'Xeon E3 - 1240',
            os: "CentOS 5",
            space:'200 جيجا بايت',
            traffic: 'مفتوح - غير محدود',
            memory : '3072 MB ميجا بايت'
        },
        class: "package-2"
    },
    {
        packageTitle: "الباقة الاولى",
        price: '199',
        options: {
            numOfProcessor: '8 معالج',
            processorType:  'Xeon E3 - 1240',
            os: "CentOS 5",
            space:'100 جيجا بايت',
            traffic: 'مفتوح - غير محدود',
            memory : '2048 MB ميجا بايت'
        },
        class: "package-1"
    },
]

const reasons = [
    'نقوم في رواد بمساعدتك في اختيار الباقة التي تناسبك مع تقديم النصائح والإرشادات ومميزات كل باقة قبل عملية الشراء',
    'يتم نقل الموقع مجاناً على سيرفرات رواد، مع توفير أقصى درجات الحماية للموقع الخاص بك',
    'ضمن لك في رواد قوة وموثوقية الأداء؛وذلك برفع معدل الإستقرار الى 99% حيث لا تحتاج كل فترة إلى إعادة الصيانة'
]

export default function VPSPage() {
    const color = '#4D51D7'

    const useStyles = makeStyles({
        root: {
            // backgroundColor: color,
            overflowX: 'hidden',
          '& header': {
              backgroundColor: color,
          }
        }
    });

    const classes = useStyles();

    return(
        <>
            <Helmet
                bodyClass={`vps ${classes.root}`}
                title="الخوادم المشتركة VPS | رواد لخدمات الويب"
                description="امتلك سيرفر VPS (الخوادم المشتركة) لضمان سرعة تحميل موقعك الإلكتروني، خبرة أكثر من 12 عام في السوق السعودي."
            />

            <BreadcrumbWithImage
                text="الخوادم المشتركة <br/> الأمان والسرعة"
                subtext="أجعل موقعك ينطلق بأداء أفضل و بصورة أسرع عبر اختيار استضافة VPS لموقعك الإلكتروني."
                img={BreadcrumbImage}
                backgroundColor={color}
            />
            <div className="page__content">

                <Features object={features} headingText="لماذا تختار خادم مشترك VPS؟" />

                <div>
                    <PageContent>
                        <Heading title="باقات سيرفرات VPS من رواد" />
                    </PageContent>
                    <PageContent>
                        <VPSPackagesTable options={options} object={packages}  />
                    </PageContent>
                </div>

                {/* <div className="vps__moreabout" style={{backgroundImage: "url(" + MoreImg + ")"}}>
                    <Container>
                        <GridItem sm={6}></GridItem>
                        <GridItem sm={6}>
                            <Heading title="إذا كنت تريد أن تتعرف أكثر علي مستويات إدارة وحماية السيرفر" />
                            <Button text="إكتشف الآن" variant="contained" background="#20D491" />
                        </GridItem>
                    </Container>
                </div> */}

                {/* <WhyRowaad object={reasons} /> */}

                <SupportWeb
                    title="لا تعرف ما هي الباقة <br/> المناسبة لك ؟"
                    content="تواصل معنا لنمنحك المساعدة مجاناً في اختيار الباقة المناسبة لك"
                    img={SupportImg}
                    backgroundColor={color}
                    color="#fff"
                    buttonBackgroundColor="#50E696"
                    btnClass="btn-request-vps"
                />
            </div>
        </>
    )
}
